import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const KekTheme = createMuiTheme({
  palette: {
    type: 'dark',
  },
})

export default KekTheme;